import { ApplicationConfig, provideZoneChangeDetection } from '@angular/core';

import { routes } from './app.routes';
import { provideHttpClient, withInterceptors } from '@angular/common/http';

import { provideTranslateHttpLoader } from '@ngx-translate/http-loader';
import { provideTranslateService } from '@ngx-translate/core';

import { tokenInterceptorFn } from './interceptors/token.interceptor';

/* PROVIDERS */
import { provideRouter, withInMemoryScrolling } from '@angular/router';
import { provideLottieOptions } from 'ngx-lottie';
import { registerLocaleData } from '@angular/common';
import { LOCALE } from '@shared/data/data';
import localeEsMX from '@angular/common/locales/es-MX';
import { LOCALE_ID } from '@angular/core';
/* PROVIDERS */

registerLocaleData(localeEsMX, LOCALE);

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true, runCoalescing: true }),
    provideRouter(
      routes,
      withInMemoryScrolling({
        scrollPositionRestoration: 'enabled'
      })
    ),
    provideHttpClient(withInterceptors([tokenInterceptorFn])),
    provideLottieOptions({
      player: () => import('lottie-web'),
    }),
    provideTranslateService({
      lang: 'es',
      fallbackLang: 'es',
      loader: provideTranslateHttpLoader({
        prefix: '/assets/i18n/',
        suffix: '.json'
      })
    }),
    { provide: LOCALE_ID, useValue: LOCALE }
  ]
};